import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { savemembershippayment, editmembershippayment, getMemberAll, getallmembershiptypes } from "../store/slices/userSlice"; // Assuming these are your API calls

Modal.setAppElement("#root");

function Membershippaymentsmodal({ isModalOpen, setIsModalOpen, reloadData, selected }) {
    const [memberlist, setmemberlist] = useState([]);
    const [membershiptypes, setmembershiptypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const bankOptions = [
        "Bank of America",
        "Chase Bank",
        "Wells Fargo",
        "Citibank",
        "U.S. Bank",
        "PNC Bank",
        "Capital One",
        "TD Bank",
        "BB&T (now Truist)",
        "Regions Bank",
        "Others"
    ];

    const initialFormData = {
        id: 0, // This should be 0 for a new payment
        date: new Date().toISOString().split("T")[0],
        member: 0, // This will be pre-filled if a member is selected
        subscription: 0,
        amount: "",
        paymentmode: "",
        transactionid: "",
        chequenumber: "",
        bank: "",
        chequedate: "",
        orderid: "",
        status: 1
    };

    const [formData, setFormData] = useState(initialFormData);

    useEffect(() => {
        const fetchDataSafely = async () => {
          try {
            await fetchAllData();
          } catch (error) {
            console.error("Error fetching all data:", error);
            // Optional: show an error popup
            // Swal.fire("Error", "Failed to fetch data", "error");
          }
        };
      
        fetchDataSafely();
      }, []);
      

    // useEffect(() => {
    //     fetchAllData();
    // }, []);

    useEffect(() => {
        try {
          if (isModalOpen) {
            if (selected) {
              // Case: Editing existing payment
              if (selected.id && selected.paymentmode) {
                setFormData({
                  id: selected.id,
                  date: selected.date
                    ? new Date(selected.date).toISOString().split("T")[0]
                    : new Date().toISOString().split("T")[0],
                  member: selected.member,
                  subscription: selected.subscription,
                  amount: selected.amount,
                  paymentmode: selected.paymentmode,
                  transactionid: selected.transactionid || "",
                  chequenumber: selected.chequenumber || "",
                  bank: selected.bank || "",
                  chequedate: selected.chequedate
                    ? new Date(selected.chequedate).toISOString().split("T")[0]
                    : "",
                  orderid: selected.orderid || "",
                  status: selected.status || 1
                });
              }
              // Case: New payment for a member
              else if (selected.id) {
                setFormData(prev => ({
                  ...initialFormData,
                  member: selected.id,
                  date: new Date().toISOString().split("T")[0]
                }));
              }
            } else {
              // Case: Modal opened with no selection, reset form
              setFormData(initialFormData);
            }
          }
        } catch (error) {
          console.error("Error in useEffect while setting form data:", error);
          // Optional: show user-friendly error
          // Swal.fire("Error", "Failed to load form data", "error");
        }
      }, [selected, isModalOpen]);
      
    const fetchAllData = async () => {
        setLoading(true);
        try {
            const memberRes = await getMemberAll();
            if (memberRes.status === 200) {
                const filtered = memberRes.data;
                setmemberlist(filtered);
            }

            const typeRes = await getallmembershiptypes();
            if (typeRes.status === 200) {
                const filtered = typeRes.data.filter((x) => x.status === '1');
                setmembershiptypes(filtered);
            }
        } catch (err) {
            setError("Error loading data.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        try {
          const { name, value } = e.target;
          let updatedFormData = { ...formData, [name]: value };
      
          if (name === "subscription") {
            const selectedType = membershiptypes?.find(
              (type) => String(type.id) === String(value)
            );
      
            if (selectedType) {
              updatedFormData.amount = selectedType.amount;
            } else {
              updatedFormData.amount = ""; // Clear amount if not found
            }
          }
      
          setFormData(updatedFormData);
        } catch (error) {
          console.error("Error in handleChange:", error);
          // Optional: user-friendly alert
          // Swal.fire("Error", "Failed to update form data", "error");
        }
      };
      

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     let updatedFormData = { ...formData, [name]: value };

    //     if (name === "subscription") {
    //         const selectedType = membershiptypes.find((type) => String(type.id) === String(value)); // Ensure comparison is safe
    //         if (selectedType) {
    //             updatedFormData.amount = selectedType.amount;
    //         } else {
    //             updatedFormData.amount = ""; // Clear amount if no subscription selected or found
    //         }
    //     }

    //     setFormData(updatedFormData);
    // };

    const handleCloseModal = () => {
        try {
          setFormData(initialFormData); // Reset form when closing
          setIsModalOpen(false);
        } catch (error) {
          console.error("Error while closing modal:", error);
          // Optional: Show user-friendly error message
          // Swal.fire("Error", "Something went wrong while closing the modal", "error");
        }
      };
      

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { member, subscription, amount, paymentmode } = formData;

        if (!member || member === 0 || !subscription || subscription === 0 || !amount || !paymentmode) {
            Swal.fire("Validation Error", "Please fill all required fields.", "warning");
            return;
        }

        if (paymentmode === "Cheque" && (!formData.chequenumber || !formData.chequedate || !formData.bank)) {
            Swal.fire("Validation Error", "Cheque details are required.", "warning");
            return;
        }

        setLoading(true);
        try {
            const response = formData.id === 0
                ? await savemembershippayment(formData)
                : await editmembershippayment(formData);

            if (response.status === 200) {
                Swal.fire("Success", `Payment ${formData.id ? "updated" : "saved"} successfully!`, "success");
                // reloadData(); // Uncomment if you have a reloadData prop that fetches updated list
                handleCloseModal(); // Close and reset form
            } else {
                Swal.fire("Error", "Operation failed!", "error");
            }
        } catch (err) {
            console.error("Payment submission error:", err);
            Swal.fire("Error", "Something went wrong!", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={handleCloseModal} // Use the custom close handler
            style={{
                overlay: { background: "rgba(0, 0, 0, 0.5)" },
                content: {
                    width: "500px",
                    margin: "auto",
                    padding: "20px",
                    borderRadius: "10px",
                },
            }}
        >
            <div className="modal-header bg-primary text-white d-flex justify-content-between align-items-center p-3">
                <h5 className="mb-0">{formData.id ? "Edit Payment" : "Add Payment"}</h5>
                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
            </div>

            <div className="modal-body">
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Form.Control type="date" name="date" value={formData.date} onChange={handleChange} required />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Member</Form.Label>
                        <Form.Select name="member" value={formData.member} onChange={handleChange} required>
                            <option value="">Select Member</option>
                            {memberlist.map((member) => (
                                <option key={member.id} value={member.id}>{member.firstname} {member.lastname}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Membership Type</Form.Label>
                        <Form.Select name="subscription" value={formData.subscription} onChange={handleChange} required>
                            <option value="">Select Membership Type</option>
                            {membershiptypes.map((type) => (
                                <option key={type.id} value={type.id}>{type.name}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control type="number" name="amount" value={formData.amount} readOnly />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Payment Mode</Form.Label>
                        <Form.Select name="paymentmode" value={formData.paymentmode} onChange={handleChange} required>
                            <option value="">Select Payment Mode</option>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Paypal">Paypal</option> {/* Corrected typo */}
                        </Form.Select>
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>Transaction Id</Form.Label> {/* Corrected typo */}
                        <Form.Control type="text" name="transactionid" value={formData.transactionid} onChange={handleChange} />
                    </Form.Group>


                    {/* Only show status for editing existing payments */}
                    {formData.id !== 0 && ( // Changed from "0" to 0 for strict comparison with number
                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                required
                            >
                                <option value={1}>Active</option>
                                <option value={0}>Inactive</option>
                            </Form.Select>
                        </Form.Group>
                    )}

                    {formData.paymentmode === "Cheque" && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label>Cheque Number</Form.Label>
                                <Form.Control type="text" name="chequenumber" value={formData.chequenumber} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Cheque Date</Form.Label>
                                <Form.Control type="date" name="chequedate" value={formData.chequedate} onChange={handleChange} />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Bank</Form.Label>
                                <Form.Select name="bank" value={formData.bank} onChange={handleChange}>
                                    <option value="">Select Bank</option>
                                    {bankOptions.map((bank) => (
                                        <option key={bank} value={bank}>{bank}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Order Id</Form.Label>
                        <Form.Control type="text" name="orderid" value={formData.orderid} onChange={handleChange} />
                    </Form.Group>

                    <div className="text-center">
                        <Button type="submit" variant="primary" disabled={loading}>
                            {loading ? "Saving..." : formData.id ? "Update" : "Submit"}
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default Membershippaymentsmodal;